import ISlaOverview from "interfaces/ISlaOverview";
import ISlaOverviewViewModel from "interfaces/ISlaOverviewViewModel";

function mapSlaOverviewToViewModel(
  slaOverview: ISlaOverview
): ISlaOverviewViewModel {
  const slaOverviewViewModel: ISlaOverviewViewModel = {
    slaDefault: slaOverview.slaDefault ?? undefined,
    dwhStartTime: slaOverview.dwhStartTime ? new Date(slaOverview.dwhStartTime) : undefined,
    dwhEndTime: slaOverview.dwhEndTime ? new Date(slaOverview.dwhEndTime) : undefined
  };

  return slaOverviewViewModel;
}

export { mapSlaOverviewToViewModel };
